import {createContext} from 'react';
import {WaiveInput, WaiveType} from '../../../../../../../shared/model/consolidate-loans';

export type WaiveInputContextType = {
  waiveInputs: WaiveInput[];
  addWaiveInputs: (loanId: number, waiveInputs: WaiveInput[]) => void;
  removeWaiveInput: (loanId: number) => void;
  handleWaiveInputValueChange: (value: number | null | undefined,
                                loanId?: number,
                                waiveType?: WaiveType,
                                feeDefinitionId?: number) => void;
}

export const WaiveInputContext = createContext<WaiveInputContextType>({} as WaiveInputContextType);
